import { computed, defineComponent, useAttrs, toRefs, inject } from "vue";
import { useFormItemCheck } from "../hook";
import "./textarea.less";
import { FormInjectionKey } from "../const";

export default defineComponent({
  name: "CInput",
  props: {
    modelValue: {
      type: [String, Number],
    },
    readonly: Boolean,
  },
  setup(props, { emit }) {
    const { modelValue, readonly } = toRefs(props);
    const notifyCheck = useFormItemCheck();
    const form = inject(FormInjectionKey, undefined);
    const attrs = useAttrs();
    const textareaAttrs = computed(() => {
      return Object.assign(
        {},
        attrs,
        // 或覆写一些监听器的行为
        {
          // 这里确保组件配合 `v-model` 的工作
          onInput: (e: Event): void => {
            const value = (e.target as HTMLInputElement).value;
            emit("update:modelValue", value);
            notifyCheck(true);
          },
          onBlur: (): void => {
            notifyCheck();
          },
          value: modelValue.value,
          readonly: readonly.value || form?.readonly,
        }
      );
    });

    return () => (
      <div class="c-textarea-box">
        <textarea {...textareaAttrs.value} class="c-textarea" />
      </div>
    );
  },
});
